import './style.scss'
import { ChangeCompanyTypeModal } from './Components/ChangeCompanyTypeModal'
import { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { thunkGetTaxAuthority } from 'features/System/systemSlice'
import { thunkCheckPackageExpiration } from 'app/authSlice'
import { useAppSelector } from 'hooks/useRedux'
import ResourceExpiredModal from './Components/ResourceExpiredModal'

function SystemNotifycationModal() {
  // Tạo và gán thông tin packageExpire từ state.auth
  const packageExpire = useAppSelector(
    (state) => state.auth.package,
    shallowEqual,
  )
  const { company } = useSelector((state) => state?.system)
  const dispatch = useDispatch()
  useEffect(() => {
    if (company.provinceId) {
      dispatch(
        thunkGetTaxAuthority({
          provinceId: company.provinceId,
        }),
      )
    }
    dispatch(thunkCheckPackageExpiration())
  }, [company, company.provinceId, dispatch])

  const [systemNotifycationModalState, setSystemNotifycationModalState] =
    useState({
      changeCompanyTypeModal: true,
      resourceExpiredModal: packageExpire?.warning || packageExpire?.expired,
    })
  useEffect(() => {
    setSystemNotifycationModalState((prev) => ({
      ...prev,
      resourceExpiredModal: packageExpire?.warning || packageExpire?.expired,
    }))
  }, [packageExpire?.warning, packageExpire?.expired])

  return (
    <>
      {company?.isUpdated == false ? (
        <ChangeCompanyTypeModal
          show={
            systemNotifycationModalState.changeCompanyTypeModal &&
            company?.isUpdated == false
          }
          // show={isShow}
          setShow={(val) =>
            setSystemNotifycationModalState((prev) => {
              return { ...prev, changeCompanyTypeModal: val }
            })
          }
          company={company}
        />
      ) : (
        <></>
      )}
      {systemNotifycationModalState.resourceExpiredModal ? (
        <ResourceExpiredModal
          open={systemNotifycationModalState.resourceExpiredModal}
          toggleModalState={(val) =>
            setSystemNotifycationModalState((prev) => {
              return { ...prev, resourceExpiredModal: val }
            })
          }
          packageExpire={packageExpire}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default SystemNotifycationModal
